const TYPE_TO_COLOR_INDEX_MAP = {
  event: 0,
  group: 1,
  petition: 2
}

// Each colour is a bootstrap theme colour built from the organisation's accent colours, so it
// comes with a `bg-`, `text-`, `border-` and `btn-` class.
const COLOR_BY_INDEX = ['primary', 'secondary', 'tertiary']

export default {
  install(app) {
    app.config.globalProperties.classFromColorIndex = function(colorIndex, classPrefix) {
      // An index we don't have a colour for falls back to the primary colour
      const color = COLOR_BY_INDEX[colorIndex] || COLOR_BY_INDEX[0]
      return { [`${classPrefix}-${color}`]: true }
    }

    app.config.globalProperties.colorIndexForType = function(typeName) {
      return TYPE_TO_COLOR_INDEX_MAP[typeName]
    }
  }
}
